document
  .getElementById("personalize-design")
  .addEventListener("click", function () {
    var productForm = document.querySelector(".shopify-product-form");
    var serializedData = new FormData(productForm);


    console.log('click');

    if (serializedData) {
      document.getElementById("personalize-design").textContent =
        "Please wait.....";

      var xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        "https://printonvinyls.com/marinevinylfabric/designnbuy/pcstudio_config/getIframeurl",
        true
      );
      xhr.onreadystatechange = function () {
        console.log(
          "Ready state change:",
          xhr.readyState,
          "Status:",
          xhr.status
        );
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            var responseText = xhr.responseText;
            console.log("redirect: " + responseText);
            if (xhr.responseText) {
              var url = new URL(responseText);
              var productId = productForm.querySelector('input[name="product-id"]')?.value;
              var selectedVariant = parseInt(productForm.querySelector('input[name="id"]')?.value);
              var sizeId = product.variants.find(v => v.id === selectedVariant)?.option_values[0];
              const parser = new DOMParser();
              const decodedSizeId = parser.parseFromString(sizeId, 'text/html').documentElement.textContent;
              url.searchParams.set("product_id", productId);
              url.searchParams.set("size_id", decodedSizeId);
            }
            window.location.href = url.toString();
          } else {
            console.error("Request failed with status:", xhr.status);
          }
        }
      };
      xhr.onerror = function () {
        console.error("Request error");
      };
      xhr.send(serializedData);
    } else {
      console.error("serializedData is not defined");
    }
  });
